import React from 'react';
import styles from './Contact.module.css';
import contactHero from '../../assets/images/gallery_6.jpg';


const Contact = () => {

  return (
    <main>
      {/* Hero */}
      <section className="page-hero" data-theme="dark">
        <img src={contactHero} alt="Contact Hero" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3))', zIndex: 0 }} />
        <div className="container page-hero__content">
          <p className="page-hero__breadcrumb">HOME / CONTACT</p>
          <h1 className="page-hero__title">
            <span className="page-hero__title-top" style={{ color: '#FFFFFF', opacity: 1 }}>GET IN</span>
            <span className="page-hero__title-bottom" style={{ color: 'var(--cyan)' }}>TOUCH.</span>
          </h1>
          <p className="page-hero__sub">
            We are here to help you start your aviation journey. Reach out to us today!
          </p>
        </div>
      </section>

      {/* Contact Form Section Sky Theme */}
      <section className={styles.formSectionSky}>
        {/* Decorative clouds */}
        <div className={styles.cloud1} />
        <div className={styles.cloud2} />
        <div className={styles.cloud3} />

        {/* Airplane SVG watermark */}
        <svg className={styles.planeSvg} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M60 4L4 28l20 8 8 20L60 4z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
          <path d="M24 36l8-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>

        <div className="container" style={{ position: 'relative', zIndex: 2, maxWidth: 1000 }}>
          <p className="label reveal" style={{ textAlign: 'center' }}>INQUIRY</p>
          <h2 className="section-title reveal" style={{ marginTop: 12, marginBottom: 16, textAlign: 'center' }}>
            Inquiry <span className="accent">Form.</span>
          </h2>
          <p className={`${styles.formSubtitle} reveal`} style={{ textAlign: 'center' }}>Fill out the form below and our team will get back to you shortly</p>

          <div className={`${styles.formBoxSky} reveal`} style={{ marginTop: '2rem' }}>
            <iframe
              src="https://forms.zohopublic.in/vinflyaviationacademy1/form/Inquiryfrom/formperma/ECKFsrPVmWZroHhauO4Q68BX9OqBDCLasFE_EaGzvcs"
              width="100%"
              height="950px"
              frameBorder="0"
              title="Admission Inquiry Form"
              style={{ border: 'none' }}
              id="admission-zoho-form"
            />
          </div>

          <div className="reveal" style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px' }}>
            <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '10px' }}>
              Form not loading?
            </p>
            <a
              href="https://forms.zohopublic.in/vinflyaviationacademy1/form/Inquiryfrom/formperma/ECKFsrPVmWZroHhauO4Q68BX9OqBDCLasFE_EaGzvcs"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '100px', fontSize: '14px', fontWeight: 'bold', background: 'var(--blue)', color: '#fff', textDecoration: 'none', boxShadow: '0 4px 14px rgba(26,115,232,0.3)' }}
            >
              Open Form in New Tab ↗
            </a>
          </div>

          <div className={styles.ctaPhoneRow} style={{ marginTop: 24, textAlign: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '8px', borderTop: '1px solid rgba(26,115,232,0.10)', paddingTop: 24 }}>
            <span className={styles.ctaPhoneLabel} style={{ color: 'var(--text-muted)', fontWeight: '500' }}>Prefer to call? Reach us at:</span>
            <a href="tel:+919960555941" className={styles.ctaPhoneLink} style={{ color: 'var(--blue)', textDecoration: 'none', fontWeight: '700' }}>+91 9960 555 941</a>
            <span className={styles.ctaPhoneSep} style={{ color: 'var(--text-ghost)' }}>·</span>
            <a href="tel:+919960555942" className={styles.ctaPhoneLink} style={{ color: 'var(--blue)', textDecoration: 'none', fontWeight: '700' }}>+91 9960 555 942</a>
          </div>
        </div>
      </section>

      {/* Info + Map */}
      <section className={`section-py ${styles.infoSection}`}>
        <div className={`container ${styles.infoGrid}`}>
          {/* Left: contact info */}
          <div className={styles.info}>
            <p className="label reveal" style={{ marginBottom: 12 }}>FIND US</p>
            <h2 className={`${styles.infoTitle} reveal`}>We're Here.</h2>

            <div className={`${styles.infoBlock} reveal`}>
              <p className={styles.infoBlockLabel}>MAIN CAMPUS</p>
              <p className={styles.infoText}>📍Gat No 452/1/1, Gandharva Nagari, Nashik Road, Moshi, Haveli, PUNE-412105</p>
            </div>
            <div className={`${styles.infoBlock} reveal`}>
              <p className={styles.infoBlockLabel}>PHONE</p>
              <a href="tel:+919960555941" className={styles.infoLink}>📞 +91 9960 555 941</a>
              <a href="tel:+919960555942" className={styles.infoLink}>📞 +91 9960 555 942</a>
            </div>
            <div className={`${styles.infoBlock} reveal`}>
              <p className={styles.infoBlockLabel}>EMAIL</p>
              <a href="mailto:contact@vinaviation.com" className={styles.infoLink}>✉ contact@vinaviation.com</a>

            </div>
            <div className={`${styles.infoBlock} reveal`}>
              <p className={styles.infoBlockLabel}>OFFICE HOURS</p>
              <p className={styles.infoText}>🕐 Monday – Saturday: 9:00 AM – 6:00 PM IST</p>
              <p className={styles.infoTextMuted}>Sunday & Public Holidays: Closed</p>
            </div>

            <div className={styles.infoDivider} />

            <div className={styles.socials}>
              <p className={styles.infoBlockLabel} style={{ marginBottom: '1rem' }}>CONNECT WITH US</p>
              <div className={styles.socialRow}>
                <a href="https://www.instagram.com/vinflyaviation?igsh=MW83bjEzeW5mOWpucw==" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="instagram" style={{ color: '#E1306C' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /><path d="M17.5 6.5h.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61583775628962" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="facebook" style={{ color: '#1877F2' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 2h-3a4 4 0 0 0-4 4v3H8v4h3v7h4v-7h3l1-4h-4V6a1 1 0 0 1 1-1h3z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </a>
                <a href="https://www.youtube.com/@VinFlyAviationAcademy" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="youtube" style={{ color: '#FF0000' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 7s-.2-1.4-.8-2c-.8-.9-1.7-.9-2.1-1C15.2 3 12 3 12 3s-3.2 0-6.9.1c-.4 0-1.3 0-2.1 1C2.2 5.6 2 7 2 7S2 8.8 2 10.6v2.8C2 16 3.2 17.4 3.2 17.4c.8 1 1.9 1 2.4 1.1C8.8 18.6 12 18.6 12 18.6s3.2 0 6.9-.1c.4 0 1.3 0 2.1-1 .6-.9.8-2 .8-2V10.6C22 8.8 22 7 22 7z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /><path d="M10 14l5-3-5-3v6z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </a>
                <a href="https://www.linkedin.com/in/vin-fly-aviation-0762b33b9" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="linkedin" style={{ color: '#0A66C2' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2c-1 0-2 .7-2 2v7h-4v-14h4v2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /><rect x="2" y="9" width="4" height="11" rx="1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /><path d="M4 4v4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </a>
              </div>
            </div>
          </div>

          {/* Right: Map placeholder */}
          <div className={`${styles.mapBox} reveal`}>
            <div className={styles.mapPlaceholder} style={{ padding: 0, overflow: 'hidden' }}>
              <iframe
                title="Location Map"
                src="https://maps.google.com/maps?q=Gat+No+452/1/1,+Gandharva+Nagari,+Nashik+Road,+Moshi,+Haveli,+PUNE-41210&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Gat+No+452/1/1,+Gandharva+Nagari,+Nashik+Road,+Moshi,+Haveli,+PUNE-41210"
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: '14px', color: 'var(--blue)', textDecoration: 'none', fontWeight: '600' }}
              >
                View Larger Map ↗
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
